import React from "react";
import { Minus, Plus } from "lucide-react";
import { useI18n } from "../lib/i18n";

const btn = "h-10 w-10 shrink-0 flex items-center justify-center bg-[#191A1F] border border-[#35353B] text-[#D4AF37] active:bg-[#D4AF37] active:text-[#101114] md:hover:bg-[#D4AF37] md:hover:text-[#101114] disabled:opacity-40 disabled:pointer-events-none transition-colors rounded-sm";

export default function QuantityStepper({ qty, setQty, stock, unit }) {
  const { t } = useI18n();
  const max = Math.max(1, stock);
  const clamp = (n) => Math.min(max, Math.max(1, Number.isFinite(n) ? Math.floor(n) : 1));
  const left = Math.max(0, stock - qty);
  return (
    <div>
      <div className="flex items-baseline justify-between gap-3 flex-wrap">
        <label className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">{t("product.quantity")}</label>
        <div data-testid="product-qty-summary" className="text-xs text-[#A8A8AD]">
          <span className="text-[#F5F3ED] font-semibold" data-testid="product-qty-units">{qty} × {unit}</span>
          <span className="mx-1.5">·</span>
          {t("product.stock_after")}: <span data-testid="product-stock-after" className={left === 0 ? "text-[#F2D98D] font-semibold" : "text-[#F5F3ED] font-semibold"}>{left}</span>
        </div>
      </div>
      <div className="mt-1.5 flex items-stretch gap-2">
        <button type="button" data-testid="product-qty-decrease-btn" aria-label={t("product.qty_decrease")}
          onClick={() => setQty(clamp(qty - 1))} disabled={qty <= 1} className={btn}><Minus size={16} /></button>
        <input data-testid="product-qty-input" type="number" inputMode="numeric" min="1" max={max} value={qty}
          onChange={(e) => setQty(e.target.value === "" ? 1 : clamp(Number(e.target.value)))}
          className="h-10 min-w-0 flex-1 text-center bg-[#191A1F] border border-[#35353B] text-[#F5F3ED] rounded-sm px-2 outline-none focus:border-[#D4AF37] [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" />
        <button type="button" data-testid="product-qty-increase-btn" aria-label={t("product.qty_increase")}
          onClick={() => setQty(clamp(qty + 1))} disabled={qty >= stock} className={btn}><Plus size={16} /></button>
      </div>
    </div>
  );
}
